import { Validators } from "@reactables/forms";
import { ValidatorFn } from "@reactables/forms";
import { Dependent } from "@basicare/common/src/Models/dependent.model";
import { RelationshipType } from "@basicare/common/src/Constants/dependents";
import { parse, isBefore, subYears } from "date-fns";
import { Organization } from "../Models/organization.model";

const maxAge =
  (age: number): ValidatorFn =>
  (value: string) => {
    const date = parse(value, "MM/dd/yyyy", new Date());
    return {
      [`maxAge${age}`]: isBefore(date, subYears(new Date(), age)),
    };
  };

const maxAge100 = maxAge(100);

export const required = Validators.required;

export const effectiveDate: ValidatorFn = (input: string) => ({
  effectiveDate: maxAge100(input).maxAge100,
});

export const dateOfBirth: ValidatorFn = (input: string) => {
  const normalizedInput = String(input).replace(/\D/g, "");

  const month = Number(normalizedInput.substring(0, 2));
  const day = Number(normalizedInput.substring(2, 4));
  const year = Number(normalizedInput.substring(4, 8));

  const date = new Date(year, month - 1, day);

  return {
    dateOfBirth:
      !(
        String(year).length === 4 &&
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day &&
        date <= new Date()
      ) || maxAge100(input).maxAge100,
  };
};

// XXX-XXX-XXXX
export const phoneNumber: ValidatorFn = (value: string) => ({
  phoneNumber: value && !/^[0-9]{3}-[0-9]{3}-[0-9]{4}$/.test(value),
});

export const emailConfirmed: ValidatorFn = ({
  email,
  confirmEmail,
}: {
  email?: string;
  confirmEmail?: string;
}) => {
  return {
    emailConfirmed: email && confirmEmail && email !== confirmEmail,
  };
};

export const dependentDateOfBirth: ValidatorFn = ({
  dateOfBirth,
  relationshipToAccountHolder,
}: Dependent) => {
  const date = parse(dateOfBirth, "MM/dd/yyyy", new Date());

  return {
    dependentDateOfBirth:
      relationshipToAccountHolder === RelationshipType.Dependent &&
      isBefore(date, subYears(new Date(), 26)),
  };
};

export const oneSpouseMax: ValidatorFn = (
  dependents: {
    confirmed: boolean;
    dependent: Dependent;
  }[]
) => {
  return {
    oneSpouseMax:
      dependents.filter(
        ({ dependent: { relationshipToAccountHolder } }) =>
          relationshipToAccountHolder === RelationshipType.Spouse
      ).length > 1,
  };
};

export const addDependentFormClosed: ValidatorFn = (dependents: {
  addDependentForm;
}) => ({
  addDependentFormClosed: Boolean(dependents.addDependentForm),
});

export const digits9orAlphaNum11: ValidatorFn = (value: string) => {
  return {
    digits9orAlphaNum11: !(
      !Boolean(value?.trim()) ||
      new RegExp(`^([0-9]{${9}})$`, "i").test(value) ||
      new RegExp(`^([0-9A-Za-z]{${11}})$`, "i").test(value)
    ),
  };
};

export const recuroNumRequiredForOrg: ValidatorFn = ({
  organization,
  recuroSubscriberNumber,
}: {
  organization?: Organization;
  recuroSubscriberNumber?: string;
}) => {
  return {
    recuroNumRequiredForOrg:
      organization &&
      organization.requiresRecuroSubscriberNumber &&
      !recuroSubscriberNumber?.trim(),
  };
};
